export default "__VITE_ASSET__CarR5pks__"